"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlaylistLibraryEventCallbacks = createPlaylistLibraryEventCallbacks;
function createPlaylistLibraryEventCallbacks(contextRef) {
    return {
        community_playlist_created: function (method, details) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_created', __assign(__assign(__assign(__assign(__assign(__assign({ context: 'community', method: method }, ((details === null || details === void 0 ? void 0 : details.items_count) != null && { items_count: details.items_count })), ((details === null || details === void 0 ? void 0 : details.target_duration_minutes) !== undefined
                && { target_duration_minutes: details.target_duration_minutes })), ((details === null || details === void 0 ? void 0 : details.has_user_edited_name) != null
                && { has_user_edited_name: details.has_user_edited_name })), ((details === null || details === void 0 ? void 0 : details.narrative_present) != null
                && { narrative_present: details.narrative_present })), ((details === null || details === void 0 ? void 0 : details.prompt_source) && { prompt_source: details.prompt_source })), ((details === null || details === void 0 ? void 0 : details.was_auto_renamed) != null
                && { was_auto_renamed: details.was_auto_renamed })));
        },
        community_playlist_deleted: function (playlistId) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_deleted', {
                context: 'community',
                playlist_id: playlistId,
            });
        },
        community_playlist_share_initiated: function (playlistTitle) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_share_initiated', {
                context: 'community',
                playlist_title: playlistTitle,
            });
        },
        community_playlist_shared: function (playlistTitle, method) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_shared', {
                context: 'community',
                playlist_title: playlistTitle,
                method: method,
            });
        },
        community_playlist_followed: function (playlistId) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_followed', {
                context: 'community',
                playlist_id: playlistId,
            });
        },
        community_playlist_unfollowed: function (playlistId) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_unfollowed', {
                context: 'community',
                playlist_id: playlistId,
            });
        },
        community_library_tab_changed: function (tab) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_library_tab_changed', {
                context: 'community',
                tab: tab,
            });
        },
        community_playlist_item_played: function (playedContentId, entryPoint, playlistId, position, ownership, viewerIsMember, contentTitle, creatorDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_item_played', __assign(__assign(__assign(__assign(__assign(__assign({ context: 'community', content_id: playedContentId, entry_point: entryPoint }, (playlistId && { playlist_id: playlistId })), (position != null && { position: position })), (ownership && { ownership: ownership })), (viewerIsMember != null && { viewer_is_member: viewerIsMember })), (contentTitle && { content_title: contentTitle })), (creatorDisplayName && { creator_display_name: creatorDisplayName })));
        },
    };
}
